// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3fizp","sendOtp":"AuthorizeToLogin_sendOtp__2wBfY"};